// extracted by mini-css-extract-plugin
module.exports = {"xpaContainer":"Matches_xpaContainer__eZLSA","scrollToTopButton":"Matches_scrollToTopButton__YB7PT"};